import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks/hooks";
import {
    selectViewerPropsVisibility,
    toggleViewerPropsVisibility,
} from "../../../../app/features/viewer/buttonsSlice/buttonsSlice";
import classes from "./ShowPropsButton.module.css";
import { ReactComponent as IconProps } from "../Buttons/icons/icon-props.svg";

function ShowPropsButton() {
    const viewerPropsVisibility = useAppSelector(selectViewerPropsVisibility);
    // useEffect(() => {
    //     dispatch(toggleViewerPropsVisibility());
    // }, []);
    const dispatch = useAppDispatch();
    return (
        <button
            className={[
                classes.ShowPropsButton,
                viewerPropsVisibility ? classes.clicked : "",
            ].join(" ")}
            onClick={() => dispatch(toggleViewerPropsVisibility())}
        >
            <IconProps
                className={[
                    classes.icon,
                    viewerPropsVisibility ? classes.clickedIcon : "",
                ].join(" ")}
            />
        </button>
    );
}

export default ShowPropsButton;
